
import React ,{useContext} from 'react'
import { Grid ,Typography , Paper } from '@material-ui/core'
import { makeStyles } from '@material-ui/core'
import { SocketContext } from '../SocketContext'


const useStyles = makeStyles((theme) => ({
  video: {
    borderRadius:"4%",
    width: '550px',
    [theme.breakpoints.down('xs')]: {
      width: '300px',
    },
  },
  gridContainer: {
    justifyContent: 'center',
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
    },
  },
  paper: {
    borderRadius:"4%",
    padding: '10px',
    margin: '10px',
  },
}));

const VideoPlayer = () => {
  const {name , callAccepted , myVideo ,userVideo , callEnded , stream , call } = useContext(SocketContext)
  const css = useStyles();

  return (
  <Grid container  className={css.gridContainer}>
        {/* our own video  */}
          {
            stream && (
              
              <Paper className={css.paper}>
              <Typography variant='h5' gutterBottom style={{textAlign:"center"}}>
                    { call.name || 'Hero'}
              </Typography>
                <Grid item xs={12} md={6}>
                
                  <video playsInline muted ref={myVideo} autoPlay className={css.video}/>
                </Grid>
              </Paper>
            )
          }
          {/* user video */}
          {
            callAccepted && !callEnded && (
              <Paper className={css.paper}>
                <Grid item xs={12} md={6}>
                  <Typography variant='h5' gutterBottom>
                    {name||'User'}
                  </Typography>
                  <video playsInline   ref={userVideo} autoPlay className={css.video}/>
                </Grid>
              </Paper>
            )
          }    
  </Grid>
  )
}

export default VideoPlayer